<template>
    <div
        :id="uniqueIdOfLoader"
        :class="['loader-castorama-c', { 'loader-castorama-c--overlay': overlay }, ...getBemModifiers()]"
    >
        <CastoC class="loader-castorama-c__icon" />
    </div>
</template>

<script>
import CastoC from '~/components/common/Animations/CastoC';
import mixinLoader from '~/src/mixins/loader';

export default {
    name: 'LoaderCastoramaC',
    availableBemModifiers: ['overlay', 'page-content-placeholder'],
    components: { CastoC },
    mixins: [mixinLoader],
};
</script>

<style lang="scss">
    .loader-castorama-c {
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        opacity: 1;
        width: 100%;
        height: 100%;
        background-color: rgba($color-castoWhite, 0.8);
        z-index: 999;
        text-align: center;
        position: absolute;

        &__icon {
            top: calc(50% - 32px);
            left: calc(50% - 32px);
            position: absolute;
            overflow: hidden;
            width: 64px;
            height: 70px;
            text-align: center;
        }

        &--overlay {
            position: fixed;
        }

        &--page-content-placeholder {
            position: relative;
            width: 100%;
            height: 316px;
        }
    }

    @media (min-width: $breakpoint-tablet) {
        .castorama-preloader--page-content-placeholder {
            width: 100%;
            height: 380px;
        }
    }
</style>
